import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/chooseApp.css';

import CreateAction from '../../components/operational/createAction';
import ChooseAppMain from './ChooseAppMain';
import { useDispatch } from 'react-redux';
import myAppsSlice from '../../redux/myAppsSlice';
const ChooseApp = () => {


  return (
    <ChooseAppMain />
  );
};

export default ChooseApp;
